<script>
import BadgeFilter from "@/components/shop/BadgeFilter.vue";
import {api} from "@/modules/api";

export default {
  name: 'ShowFilters',
  components: {BadgeFilter},
  data () {
    return {
      filters: {},
      options: {}
    }
  },
  mounted () {
    this.emitter.on('filter-shop', (event) => {
      this.filters = event
    })
    this.loadOptions()
  },
  computed: {
    showFilter () {
      return Object.keys(this.filters).map(key => {
        if (key === 'price') {
          return { id: 'price', value: `${this.filters[key].min} - ${this.filters[key].max}€` }
        } else if (key === 'category') {
          const filtre = Object.values(this.options).filter(item => {
            return item.id === this.filters[key]
          })
          return {id: 'category', value: filtre[0].Label}
        }
      })
    }
  },
  methods: {
    loadOptions () {
      api.categories.options().then(response => {
        this.options = response
      })
    }
  }
}
</script>

<template>
  <div v-if="filters" class="my-5 flex justify-start">
    <badge-filter v-for="(item, index) in showFilter" :key="index" :item="item" />
  </div>
</template>
